import { dismiss } from './dismiss';
import { getDeviceName } from './getDeviceName';
import { logout } from './logout';
import { openCamera } from './openCamera';
import { openChat } from './openChat';
import { openPhotoCollection } from './openPhotoCollection';
import { openUrl } from './openUrl';
import { pageLoaded } from './pageLoaded';
import { redirectToHome } from './redirectToHome';
import { retryPhotoCollection } from './retryPhotoCollection';

export type { Actions, NativeAppAction, NativeUniclientAction } from './types';
export { invokeAction } from './invoke';

export const actions = {
  dismiss,
  getDeviceName,
  pageLoaded,
  logout,
  openCamera,
  openChat,
  redirectToHome,
  openUrl,
  openPhotoCollection,
  retryPhotoCollection,
};
